import { Star, Quote, ArrowUpRight, MapPin } from "lucide-react";
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";
const CREAM_DEEP = "#F0EBE0";
const INK = "#1A1F2E";
const INK_MUTED = "#5A6478";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
type Review = {
  name: string;
  suburb: string;
  service: string;
  date: string;
  rating: number;
  quote: string;
  initials: string;
};
const FEATURED: Review = {
  name: "Daniel R.",
  suburb: "Drummoyne",
  service: "B&D Panelift — single panel swap",
  date: "April 2026",
  rating: 5,
  quote: "Reversed into our garage door — completely smashed the bottom panel. Two other quotes said we needed a whole new door — around $2,800. Gold came out, took photos, came back the next day with a matching B&D Panelift panel from their stock. Replaced it in under two hours. Looks brand new. Half the price of the other quotes.",
  initials: "DR"
};
const REVIEWS: Review[] = [{
  name: "Karen M.",
  suburb: "Roseville",
  service: "Steel-Line track repair",
  date: "March 2026",
  rating: 5,
  quote: "Steel-Line door came off the tracks after a storm. Tech straightened the tracks, replaced two bent rollers, and aligned the whole system. Saved us from a full track replacement quote we'd received elsewhere.",
  initials: "KM"
}, {
  name: "Tom B.",
  suburb: "Kogarah",
  service: "Hinge & roller replacement",
  date: "March 2026",
  rating: 5,
  quote: "Door was making a horrible grinding sound every morning. Tech identified worn nylon rollers and a snapped hinge — all replaced in 90 minutes. Door is whisper-quiet now. Wish I'd called sooner.",
  initials: "TB"
}, {
  name: "Rachel S.",
  suburb: "Manly",
  service: "Weather seal renewal",
  date: "February 2026",
  rating: 5,
  quote: "Bottom seal was perished — rain was coming into the garage. Gold renewed the bottom seal, side weatherstrips, and the top jamb seal. Garage is dry again. Quick, clean, professional work.",
  initials: "RS"
}, {
  name: "Pavlos A.",
  suburb: "Marrickville",
  service: "Centurion panel match",
  date: "February 2026",
  rating: 5,
  quote: "Our Centurion Boss had a dented top panel from a tradesman's ladder. Gold matched the colour and embossing perfectly — you genuinely can't tell which panel was replaced. Honest pricing, great work.",
  initials: "PA"
}];
export default function SectionalTestimonials() {
  return <section style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    padding: "120px 24px",
    fontFamily: FONT_BODY
  }}>
      <div aria-hidden style={{
      position: "absolute",
      top: 60,
      right: -40,
      fontFamily: FONT_HEAD,
      fontSize: "clamp(160px, 20vw, 280px)",
      fontWeight: 900,
      color: CREAM_DEEP,
      opacity: 0.55,
      letterSpacing: "-0.04em",
      lineHeight: 1,
      pointerEvents: "none",
      userSelect: "none",
      zIndex: 0
    }}>
        REVIEWS
      </div>

      <div aria-hidden style={{
      position: "absolute",
      top: 80,
      left: 24,
      width: 120,
      height: 1,
      background: GOLD,
      zIndex: 1
    }} />

      <div style={{
      position: "relative",
      zIndex: 2,
      maxWidth: 1200,
      margin: "0 auto"
    }}>
        {/* === HEADER === */}
        <div style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
        gap: 60,
        marginBottom: 64,
        alignItems: "end"
      }} className="sectional-test-header">
          <div>
            <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 20
          }}>
              <span style={{
              fontFamily: FONT_BODY,
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              color: GOLD_DARK
            }}>
                07 / Sydney verdict
              </span>
              <span style={{
              width: 32,
              height: 1,
              background: GOLD
            }} />
            </div>

            <h2 style={{
            fontFamily: FONT_HEAD,
            fontSize: "clamp(34px, 4.5vw, 56px)",
            fontWeight: 800,
            color: INK,
            lineHeight: 1.05,
            letterSpacing: "-0.025em",
            margin: 0
          }}>
              The customers we{" "}
              <span style={{
              color: GOLD_DARK,
              fontStyle: "italic",
              fontWeight: 700
            }}>
                saved from full door replacement.
              </span>
            </h2>
          </div>

          {/* Rating badge */}
          <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 16
        }} className="sectional-test-badge-wrap">
            <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 14,
            padding: "16px 24px",
            background: "#ffffff",
            border: `1px solid ${CREAM_DEEP}`,
            borderRadius: 8,
            boxShadow: "0 4px 16px rgba(8,20,56,0.05)"
          }}>
              <div style={{
              display: "flex",
              gap: 2
            }}>
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={18} fill={GOLD} color={GOLD} strokeWidth={0} />)}
              </div>
              <div>
                <div style={{
                fontFamily: FONT_HEAD,
                fontSize: 22,
                fontWeight: 800,
                color: INK,
                lineHeight: 1,
                letterSpacing: "-0.01em"
              }}>
                  5.0
                </div>
                <div style={{
                fontFamily: FONT_BODY,
                fontSize: 11,
                fontWeight: 600,
                color: INK_MUTED,
                marginTop: 2
              }}>
                  100+ Google reviews
                </div>
              </div>
            </div>
            <div style={{
            fontFamily: FONT_BODY,
            fontSize: 13,
            color: INK_MUTED,
            fontStyle: "italic"
          }}>
              Every review verified by Google.
            </div>
          </div>
        </div>

        {/* === FEATURED REVIEW === */}
        <div style={{
        position: "relative",
        background: "#ffffff",
        border: `1px solid ${CREAM_DEEP}`,
        borderLeft: `4px solid ${GOLD}`,
        borderRadius: 4,
        padding: "48px 56px",
        marginBottom: 32,
        overflow: "hidden"
      }} className="sectional-test-featured">
          <Quote size={64} color={GOLD} strokeWidth={1.5} style={{
          position: "absolute",
          top: 32,
          right: 40,
          opacity: 0.15
        }} />

          <div style={{
          display: "grid",
          gridTemplateColumns: "auto minmax(0, 1fr)",
          gap: 40,
          alignItems: "start"
        }} className="sectional-test-featured-grid">
            <div style={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            background: NAVY,
            color: GOLD,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: FONT_HEAD,
            fontSize: 28,
            fontWeight: 800,
            letterSpacing: "0.02em",
            flexShrink: 0
          }}>
              {FEATURED.initials}
            </div>

            <div>
              <div style={{
              display: "flex",
              gap: 3,
              marginBottom: 20
            }}>
                {[1, 2, 3, 4, 5].map(i => <Star key={i} size={18} fill={GOLD} color={GOLD} strokeWidth={0} />)}
              </div>

              <blockquote style={{
              fontFamily: FONT_HEAD,
              fontSize: "clamp(20px, 1.9vw, 26px)",
              fontWeight: 500,
              color: INK,
              lineHeight: 1.45,
              letterSpacing: "-0.01em",
              margin: "0 0 32px",
              fontStyle: "italic"
            }}>
                "{FEATURED.quote}"
              </blockquote>

              <div style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 20,
              paddingTop: 24,
              borderTop: `1px solid ${CREAM_DEEP}`
            }}>
                <div>
                  <div style={{
                  fontFamily: FONT_HEAD,
                  fontSize: 17,
                  fontWeight: 800,
                  color: INK,
                  letterSpacing: "-0.005em"
                }}>
                    {FEATURED.name}
                  </div>
                  <div style={{
                  fontFamily: FONT_BODY,
                  fontSize: 13,
                  color: INK_MUTED,
                  marginTop: 4,
                  display: "flex",
                  alignItems: "center",
                  gap: 6
                }}>
                    <MapPin size={12} strokeWidth={2} />
                    {FEATURED.suburb}
                  </div>
                </div>
                <div style={{
                width: 1,
                height: 28,
                background: CREAM_DEEP
              }} />
                <div>
                  <div style={{
                  fontFamily: FONT_BODY,
                  fontSize: 10,
                  fontWeight: 800,
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  color: GOLD_DARK,
                  marginBottom: 4
                }}>
                    Job completed
                  </div>
                  <div style={{
                  fontFamily: FONT_BODY,
                  fontSize: 14,
                  color: INK,
                  fontWeight: 500
                }}>
                    {FEATURED.service} · {FEATURED.date}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* === GRID OF 4 REVIEWS === */}
        <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 20,
        marginBottom: 56
      }} className="sectional-test-grid">
          {REVIEWS.map((r, i) => <ReviewCard key={i} review={r} />)}
        </div>

        {/* === BOTTOM CTA STRIP === */}
        <div style={{
        padding: "32px 40px",
        background: "#ffffff",
        border: `1px solid ${CREAM_DEEP}`,
        borderLeft: `3px solid ${GOLD}`,
        borderRadius: 4,
        display: "flex",
        flexWrap: "wrap",
        gap: 24,
        alignItems: "center",
        justifyContent: "space-between"
      }}>
          <div>
            <div style={{
            fontFamily: FONT_BODY,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: GOLD_DARK,
            marginBottom: 8
          }}>
              Read every review on Google
            </div>
            <div style={{
            fontFamily: FONT_HEAD,
            fontSize: 19,
            fontWeight: 600,
            color: INK,
            lineHeight: 1.3,
            letterSpacing: "-0.005em"
          }}>
              100+ verified reviews. No filters, no edits, no fake five stars.
            </div>
          </div>

          <a href="https://www.google.com/search?q=gold+garage+door+sydney+reviews" target="_blank" rel="noopener noreferrer" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "14px 22px",
          background: NAVY,
          color: "#ffffff",
          fontFamily: FONT_HEAD,
          fontSize: 14,
          fontWeight: 700,
          borderRadius: 8,
          textDecoration: "none",
          whiteSpace: "nowrap",
          transition: "background 0.2s, transform 0.2s"
        }} onMouseEnter={e => {
          e.currentTarget.style.background = NAVY_LIGHT;
          e.currentTarget.style.transform = "translateY(-2px)";
        }} onMouseLeave={e => {
          e.currentTarget.style.background = NAVY;
          e.currentTarget.style.transform = "translateY(0)";
        }}>
            View all Google reviews
            <ArrowUpRight size={16} strokeWidth={2.5} />
          </a>
        </div>
      </div>

      {/* Responsive */}
      <style>{`
        @media (max-width: 900px) {
          .sectional-test-header {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
            align-items: start !important;
          }
          .sectional-test-badge-wrap {
            align-items: flex-start !important;
          }
          .sectional-test-featured {
            padding: 36px 28px !important;
          }
          .sectional-test-featured-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
          .sectional-test-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>;
}
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <div className="sectional-review-card" style={{
    position: "relative",
    padding: "32px 28px",
    background: "#ffffff",
    border: `1px solid ${CREAM_DEEP}`,
    borderRadius: 4,
    transition: "transform 0.2s, border-color 0.2s, box-shadow 0.2s",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    minHeight: 260
  }} onMouseEnter={e => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.borderColor = GOLD;
    e.currentTarget.style.boxShadow = "0 12px 32px rgba(8,20,56,0.08)";
  }} onMouseLeave={e => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.borderColor = CREAM_DEEP;
    e.currentTarget.style.boxShadow = "none";
  }}>
      <div style={{
      display: "flex",
      alignItems: "center",
      gap: 14,
      marginBottom: 18
    }}>
        <div style={{
        width: 44,
        height: 44,
        borderRadius: "50%",
        background: CREAM,
        border: `1px solid ${CREAM_DEEP}`,
        color: GOLD_DARK,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: FONT_HEAD,
        fontSize: 14,
        fontWeight: 800,
        letterSpacing: "0.02em",
        flexShrink: 0
      }}>
          {review.initials}
        </div>

        <div style={{
        flex: 1,
        minWidth: 0
      }}>
          <div style={{
          fontFamily: FONT_HEAD,
          fontSize: 15,
          fontWeight: 800,
          color: INK,
          letterSpacing: "-0.005em"
        }}>
            {review.name}
          </div>
          <div style={{
          fontFamily: FONT_BODY,
          fontSize: 12,
          color: INK_MUTED,
          marginTop: 2,
          display: "flex",
          alignItems: "center",
          gap: 4
        }}>
            <MapPin size={10} strokeWidth={2} />
            {review.suburb}
          </div>
        </div>

        <div style={{
        display: "flex",
        gap: 2
      }}>
          {[1, 2, 3, 4, 5].map(i => <Star key={i} size={12} fill={GOLD} color={GOLD} strokeWidth={0} />)}
        </div>
      </div>

      <p style={{
      fontFamily: FONT_BODY,
      fontSize: 14,
      color: INK,
      lineHeight: 1.6,
      margin: "0 0 20px",
      flex: 1
    }}>
        "{review.quote}"
      </p>

      <div style={{
      paddingTop: 16,
      borderTop: `1px solid ${CREAM_DEEP}`,
      display: "flex",
      flexWrap: "wrap",
      gap: 12,
      alignItems: "center",
      justifyContent: "space-between"
    }}>
        <div style={{
        fontFamily: FONT_BODY,
        fontSize: 12,
        color: INK_MUTED,
        fontWeight: 500
      }}>
          {review.service}
        </div>
        <div style={{
        fontFamily: FONT_BODY,
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: "0.15em",
        textTransform: "uppercase",
        color: GOLD_DARK
      }}>
          {review.date}
        </div>
      </div>
    </div>;
}